import { createContext, useCallback, useContext, useMemo, useState } from "react";
import GetAppDialog from "@/components/GetAppDialog";

const GetAppContext = createContext(null);

export function GetAppProvider({ children }) {
  const [feature, setFeature] = useState(null);
  const openGetApp = useCallback((label) => setFeature(label || "This feature"), []);
  const value = useMemo(() => ({ openGetApp }), [openGetApp]);

  return (
    <GetAppContext.Provider value={value}>
      {children}
      <GetAppDialog feature={feature} onClose={() => setFeature(null)} />
    </GetAppContext.Provider>
  );
}

export const useGetApp = () => useContext(GetAppContext).openGetApp;
